import React, { useReducer } from "react"

// TODO: TS integration
export const defaultInterfaceContext = {
  collectionMethodChanged: false,
  setCollectionMethodChanged: (val) => {},
  hideDrawers: () => {},
}

export const InterfaceContext = React.createContext(defaultInterfaceContext)

export default React.createContext(defaultInterfaceContext)

export const InterfaceProvider = ({ children }) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case "hideDrawers":
        return {
          ...state,
          showCart: false,
        }

      case "setCollectionMethodChanged":
        return {
          ...state,
          collectionMethodChanged: action.payload,
        }
    }
  }

  const [state, dispatch] = useReducer(reducer, defaultInterfaceContext)

  const hideDrawers = () => {
    dispatch({ type: "hideDrawers" })
  }

  const setCollectionMethodChanged = (payload) => {
    dispatch({ type: "setCollectionMethodChanged", payload })
  }

  return (
    <InterfaceContext.Provider
      value={{
        ...state,
        hideDrawers,
        setCollectionMethodChanged,
      }}
    >
      {children}
    </InterfaceContext.Provider>
  )
}
